// extracted by mini-css-extract-plugin
export default {"lessons":"gNrGR","lesson":"ij1T0","lessonMenu":"RDwuA"};